import { LucideIcon } from 'lucide-react';
import React from 'react';
import { Button } from '@/components/ui/button';

interface ActionButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  loadingText: string;
  normalText: string;
  icon: LucideIcon;
  variant?:
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link'
    | 'shelve';
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  disabled = false,
  loading = false,
  loadingText,
  normalText,
  icon: Icon,
  variant = 'default',
  className = '',
  type,
}) => {
  return (
    <Button
      onClick={onClick}
      type={type}
      disabled={disabled || loading}
      variant={variant}
      className={className}
    >
      {loading ? (
        <>
          <Icon className="h-4 w-4 mr-2 animate-spin" />
          {loadingText}
        </>
      ) : (
        <>
          <Icon className="h-4 w-4 mr-2" />
          {normalText}
        </>
      )}
    </Button>
  );
};
